import * as React from 'react';

const EmptyData: React.FunctionComponent = () => {
  return (
    <div className="metrics-data empty">No Metrics for date range</div>
  );
};

export default EmptyData;
